import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DocumentService} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-upload-pm-document',
  templateUrl: 'upload.pm.document.component.html'
})
export class UploadPmDocumentComponent {

  filesToUpload: File[];

  constructor(private dialogRef: MatDialogRef<UploadPmDocumentComponent>, @Inject(MAT_DIALOG_DATA) private data: UploadPmDocumentData,
              private ds: DocumentService) {
  }

  filesChanged(files: File[]) {
    this.filesToUpload = files;
  }

  cancel() {
    this.dialogRef.close();
  }

  uploadFiles() {
    this.ds.insertOfficeDocument(Array.from(this.filesToUpload), this.data.containerId).subscribe(result => {
      console.log(result);
      this.dialogRef.close();
    });
  }

}

export interface UploadPmDocumentData {
  containerId: string;
}
